// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"82":"455ddd05","84":"3bfcefec","247":"bff653b9","440":"4097b1b4","453":"2b12ac4a","627":"5474222b","738":"fab90171","834":"1bf6c83c","923":"ad6985e2","938":"f86a5339"}[chunkId] + ".chunk.js";
};